import { render, staticRenderFns } from "./SessaoExpirada.vue?vue&type=template&id=ef5261c8&scoped=true"
import script from "./SessaoExpirada.vue?vue&type=script&lang=js"
export * from "./SessaoExpirada.vue?vue&type=script&lang=js"
import style0 from "./SessaoExpirada.vue?vue&type=style&index=0&id=ef5261c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5261c8",
  null
  
)

export default component.exports